import React, { useState, useMemo, useEffect } from 'react';
import { Button, Card, Col, Container, Form, Modal, Offcanvas, Row } from 'react-bootstrap';
import Breadcrumb from '../../Common/BreadCrumb';
import TableContainer from "../../Common/TableContainer";
import { couponsList } from "../../Common/data";
import { Link, useNavigate, useParams } from 'react-router-dom';
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import *  as Yup from 'yup'
import moment from "moment";
import { yupResolver } from "@hookform/resolvers/yup";
import offerbanner from "../../assets/images/ecommerce/offer-banner.jpg";
import FormProvider from '../../FunctionalComponent/FormElement/FormProvider';
import { useForm } from 'react-hook-form';
import RHFTextField from '../../FunctionalComponent/FormElement/RHTextField';
import RHSelectField from '../../FunctionalComponent/FormElement/RHSelectField';
import RHFileUpload from '../../FunctionalComponent/FormElement/RHFileUpload';
import { useCouponlistMutation, useCreate_Update_CouponMutation, useDeletecouponMutation, useGetCouponDataMutation, useGetCouponslistQuery } from '../../Redux/CouponSlice';
import { useUplaodFileMutation } from '../../Redux/file/fileApi';
import { useCategoryListMutation, useGetCategoriesListQuery } from '../../Redux/category/categoryApi';
import { getQueryString } from '../../lib/Validationtext';
import { useActiveProductlistMutation, useGetActiveProductslistQuery } from '../../Redux/ProductSlice';
import DeleteModal from '../../Common/modals/DeleteModal';
import { toast } from 'react-toastify'
import useDebounce from '../../hooks/useDebounce';
import BannerFileUpload from '../../FunctionalComponent/FormElement/BannerFileUpload';



const AddCoupon = () => {

  const navigate = useNavigate()
  const [search, setSearch] = useState('')
  document.title = "Coupons | Toner eCommerce + Admin React Template";
  const [fileUploadFn, { data: fileData }] = useUplaodFileMutation();
  const [CreateUpdateCouponFunc, { data: addSuccessData, isSuccess: addCouponSuccess, error: addErrCoupn, isLoading }] = useCreate_Update_CouponMutation();
  // const [categoryListFn, { data: listData, error: listErr, isLoading: listLoading }] = useCategoryListMutation();

  const debounceSearch = useDebounce(search, 300);
  const { data: listData, error: listErr, isLoading: listLoading } = useGetCategoriesListQuery();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // const [couponlistFunc, { data: CouponlistData, }] = useCouponlistMutation();
  const { data: CouponlistData, isFetching } = useGetCouponslistQuery(debounceSearch);
  const { data: productlistData } = useGetActiveProductslistQuery();
  const [GetCouponFunc] = useGetCouponDataMutation();
  const [couponImage, setcouponImage] = useState(null);
  const [CouponData, setCouponData] = useState();
  const [selectedRadio, setSelectedRadio] = useState('category');
  const [showCouponImage, setShowCouponImage] = useState(true);
  const [couponimagefile, setCouponImagefile] = useState(null)
  const [imagePath, setImagepath] = useState()

  const defaultValues = {
    id: "",
    name: '',
    code: '',
    discountType: '',
    discountValue: '',
    maxUsageCount: '',
    minimumBuyAmount: '',
    startDate: '',
    endDate: '',
    isApplicableForPromo: '',
    couponImage: '',
    categoryId: [],
    productId: [],
    isShownHomePage: '',
    applyFor: '',
    isActive: '',
    type: '', //promo,coupon
    // isShownSticky: '',
  };
  const [isApplicableForPromo, setIsApplicableForPromo] = useState();

  const handlePromoChange = (e) => {
    setIsApplicableForPromo(e.target.value === 'true');
  };
  const couponSchema = Yup.object().shape({
    name: Yup
      .string()
      .required('Coupon title is a required field')
      .strict(true)
      .trim('White spaces before and after are not allow'),
    code: Yup
      .string()
      .required()
      .strict(true)
      .trim('White spaces before and after are not allow'),
    isActive: Yup.string().required('Status is required'),
    discountType: Yup.string().required('Discount Type is required'),
    // discountValue: Yup.number().required(),
    discountValue: Yup.number()
      .positive('Discount value must be a positive number')
      .typeError('Discount value is required & value must be a number'),
    maxUsageCount: Yup.number()
      .positive('Discount value must be a positive number')
      .typeError('Coupon can use is required & value must be a number'),
    minimumBuyAmount: Yup.number()
      .positive('Discount value must be a positive number')
      .typeError('Coupon min price is required & value must be a number'),
    startDate: Yup.string()
      .required('Start date use is required'),
    endDate: Yup.string().required('End date use is required'),
    isApplicableForPromo: Yup.string().required('Promo use is required'),

  });
  let CouponIDData = useParams();
  const CouponID = CouponIDData?.id;

  useEffect(() => {
    if (CouponID) {
      GetCouponFunc(CouponID).then(res => {
        const getsizedata = res?.data?.response
        console.log('getsizedata', getsizedata)
        Object.keys(defaultValues).forEach((fieldname) => {
          let value = getsizedata[`${fieldname}`];
          if (fieldname === 'startDate' || fieldname === 'endDate') {
            setValue(fieldname, moment(getsizedata[fieldname]).format('YYYY-MM-DD'))
          }
          if (fieldname === 'categoryId') {

            value = getsizedata?.CouponCategoryCombinations?.map(item => ({ label: item?.Category?.name, value: item?.Category?.id }));
            if (value.length > 0) {
              setSelectedRadio("category")
            }
          } else if (fieldname === 'productId') {
            value = getsizedata?.CouponProductCombinations?.map(item => ({ label: item?.Product?.productTitle, value: item?.Product?.id }));
            if (value.length > 0) {
              setSelectedRadio("product")
            }
          }
          if (fieldname === 'couponImage') {
            const imageValue = getsizedata[`${fieldname}`]
            setImagepath(imageValue)
          }

          setValue(fieldname, value);
          // setValue({ ...fieldname, productId: productvalue });
        })
      })
    }
  }, [CouponData])


  const handleFileChange = async (e, setFile, name) => {
    const file = e.target.files?.[0];
    const fileName = e.target.name;
    setShowCouponImage(true);
    const maxFileSizeMap = {
      couponImage: 1024 * 10,
    };
    const maxSizeKB = maxFileSizeMap[fileName];

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (reader.readyState === 2) {
          const fileSize = file.size / 1024;
          const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];

          if (!allowedTypes.includes(file.type)) {
            toast.error("Image type not supported. Please choose a jpg, jpeg, png file.");
            return;
          }
          if (fileSize > maxSizeKB) {
            toast.error(`File size exceeds maximum limit (${maxSizeKB / 1024}MB). Please choose a smaller file.`);
            return;
          }
          uploadFile(file)
          setCouponImagefile(reader.result);
        }
      };
      reader.readAsDataURL(file);
      setFile(file);
    }
  };

  const uploadFile = async (file) => {
    if (!file) {
      // If there's no file to upload, resolve immediately
      return;
    }
    try {
      const formData = new FormData();
      formData.append("image", file);
      const response = await fileUploadFn(formData);
      setImagepath(response?.data?.response?.url)
      return response?.data?.response?.url

    } catch (error) {
      throw error;
    }
  };


  const methods = useForm({
    resolver: yupResolver(couponSchema),
    defaultValues,
    mode: 'all',
  });

  const {
    reset,
    setError,
    setValue,
    handleSubmit,
    getValues,
    watch,
    formState: { errors },
  } = methods;

  const watchcall = watch();
  console.log('watchcall', watchcall)

  const onSubmit = async (data) => {
    console.log('data', data);
    console.log('getValues', getValues("couponImage"));
    const categoryvalue = selectedRadio === "category" ? data?.categoryId.map(item => item.value) : [];
    const productvalue = selectedRadio === 'product' ? data?.productId.map(item => item.value) : [];
    try {
      const promiseAll = await Promise.all([
        uploadFile(couponImage),
      ]);
      CreateUpdateCouponFunc({
        ...data, productId: productvalue, categoryId: categoryvalue,
        couponImage: imagePath,
      }).then((res) => {
        if (res?.data?.statusCode == 201 || res?.data?.statusCode == 200) {
          setcouponImage(null)
          const message = res?.data?.message || "Coupon added  successfully";
          toast.success(message);
          navigate("/coupons");
        }

      })
    } catch (error) {
      setError("afterSubmit", {
        ...error,
        message: toast.error(error.message),

      });

      console.log('message', error, error.message)
    }
  };

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (endDate && date[0] > endDate[0]) {
      setEndDate(null);
      toast.error('End date must be after the start date');
    }
  };
  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (startDate && date[0] < startDate[0]) {
      setStartDate(null);
      toast.error('End date must be after the start date');
    }
  };

  const handleDeleteImage = (imageType) => {
    if (imageType == "couponImage") {
      setValue('couponImage', '');
      setShowCouponImage(false);
    }
  };

  console.log('productlistData', productlistData)

  return (
    <>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title={CouponID ? "Update Coupons" : "Add Coupons"} pageTitle="More" />
          <div id="couponsList">
            <FormProvider className="tablelist-form" methods={methods} onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg={3}>
                  <div className="mb-3">
                    <RHFTextField name='name' label='Coupon Title' required />
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="mb-3">
                    <RHFTextField name='code' label='Coupon Code' required />
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="mb-3">
                    <RHSelectField name='discountType' label='Discount Type' list={[
                      { name: 'Fixed', value: 'fixed' },
                      { name: 'Percentage', value: 'percentage' },
                    ]} />
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="mb-3">
                    <RHFTextField name='discountValue' label='Discount Value' required />
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="mb-3">
                    <RHFTextField name='maxUsageCount' label='Coupon can use' required />
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="mb-3">
                    <RHFTextField name='minimumBuyAmount' label='Coupon Min Price' required />
                  </div>
                </Col>
                {/* <Col lg={3}>
                  <div className="mb-3">
                    <Form.Label htmlFor="startDate">Start Date<span className="text-danger">*</span></Form.Label>
                    <Flatpickr
                      className="form-control flatpickr-input"
                      placeholder='Select date'
                      options={{
                        dateFormat: "d M, Y",
                      }}
                      onChange={(e) => setValue('startDate', e?.[0])}
                      value={getValues('startDate')}
                    />
                    <div className="invalid-feedback">{errors?.startDate?.message}</div>
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="mb-3">
                    <Form.Label htmlFor="endDate">End Date<span className="text-danger">*</span></Form.Label>
                    <Flatpickr
                      className="form-control flatpickr-input"
                      placeholder='Select date'
                      options={{
                        dateFormat: "d M, Y",
                      }}
                      onChange={(e) => setValue('endDate', e?.[0])}
                      value={getValues('endDate')}
                    />
                    <div className="invalid-feedback">{errors?.endDate?.message}</div>
                  </div>
                </Col> */}
                <Col lg={3}>
                  <div className="mb-3">
                    <Form.Label htmlFor="startDate">Start Date<span className="text-danger">*</span></Form.Label>
                    <Flatpickr
                      className="form-control flatpickr-input"
                      placeholder='Select date'
                      options={{
                        dateFormat: "d M, Y",
                      }}
                      onChange={(date) => handleStartDateChange(date)}
                      value={startDate}
                    />
                    <div className="invalid-feedback">{/* Add validation message if needed */}</div>
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="mb-3">
                    <Form.Label htmlFor="endDate">End Date<span className="text-danger">*</span></Form.Label>
                    <Flatpickr
                      className="form-control flatpickr-input"
                      placeholder='Select date'
                      options={{
                        dateFormat: "d M, Y",
                      }}
                      onChange={(date) => handleEndDateChange(date)}
                      value={endDate}
                    />
                    <div className="invalid-feedback">{/* Add validation message if needed */}</div>
                  </div>
                </Col>


                <Col lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Promo</Form.Label>
                    <Form.Select
                      name='isApplicableForPromo'
                      onChange={handlePromoChange}
                      value={isApplicableForPromo}
                    >
                      <option value=''>Select Promo</option>
                      <option value='false'>Not Applicable</option>
                      <option value='true'>Applicable</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col lg={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Type</Form.Label>
                    <Form.Select
                      name='type'
                      value={isApplicableForPromo ? 'promo' : 'coupon'}
                      disabled={isApplicableForPromo}
                    >
                      <option value=''>Select option</option>
                      <option value='coupon'>Coupon</option>
                      <option value='promo'>Promo</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col lg={3}>
                  <div className="mb-3">
                    <div>
                      <label htmlFor="" className='mb-2 fw-medium'>Select</label>
                    </div>
                    <div className="btn-group radio w-100" role="group">
                      <input type="radio" className="btn-check" name="data-layout-position" id="layout-position-fixed" checked={selectedRadio === 'category'}
                        onChange={() => setSelectedRadio('category')} />
                      <label className="btn btn-light w-sm" htmlFor="layout-position-fixed">Category</label>
                      <input type="radio" className="btn-check" name="data-layout-position" id="layout-position-scrollable" checked={selectedRadio === 'product'}
                        onChange={() => setSelectedRadio('product')} />
                      <label className="btn btn-light w-sm ms-0" htmlFor="layout-position-scrollable">Product</label>
                    </div>
                  </div>
                </Col>
                {selectedRadio === 'category' && (
                  <Col lg={3}>
                    <div className="mb-3">
                      <label htmlFor="" className='mb-2 fw-medium'>Select Category</label>
                      <Select
                        name='categoryId'
                        isMulti
                        options={listData?.response?.length && listData?.response?.map(item => ({ label: item?.name, value: item?.id })) || [{}]}
                        placeholder="Select Category"
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            border: '1px solid #ced4da',
                            borderRadius: '0.25rem',
                            boxShadow: 'none',
                            '&:hover': {
                              borderColor: '#ced4da',
                            },
                          }),
                          multiValueLabel: (provided) => ({
                            ...provided,
                            color: '#fff',
                            backgroundColor: '#007bff',
                          }),
                          multiValueRemove: (provided) => ({
                            ...provided,
                            color: '#fff',
                            backgroundColor: '#007bff',
                            borderRadius: '0.25rem',
                            '&:hover': {
                              backgroundColor: '#0056b3',
                            },
                          }),
                        }}
                        onChange={(e) => {
                          setValue('categoryId', e)
                        }}
                        value={getValues('categoryId')}
                      />
                    </div>
                  </Col>)}
                {selectedRadio === 'product' && (
                  <Col lg={3}>
                    <div className="mb-3">
                      <label htmlFor="" className='mb-2 fw-medium'>Select Product</label>
                      <Select
                        name='productId'
                        isMulti
                        options={productlistData?.response?.length && productlistData?.response?.map(item => (
                          { label: item?.Product.productTitle, value: item?.Product?.id })) || [{}]}
                        placeholder="Select Product"
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            border: '1px solid #ced4da', // Bootstrap-style border
                            borderRadius: '0.25rem', // Bootstrap-style border radius
                            boxShadow: 'none', // Remove box shadow
                            '&:hover': {
                              borderColor: '#ced4da', // Border color on hover
                            },
                          }),
                          multiValueLabel: (provided) => ({
                            ...provided,
                            color: '#fff', // Text color for selected options
                            backgroundColor: '#007bff', // Background color for selected options
                          }),
                          multiValueRemove: (provided) => ({
                            ...provided,
                            color: '#fff', // Remove button color for selected options
                            backgroundColor: '#007bff', // Background color for selected options
                            borderRadius: '0.25rem', // Bootstrap-style border radius
                            '&:hover': {
                              backgroundColor: '#0056b3', // Background color on hover
                            },
                          }),
                        }}
                        onChange={(e) => {

                          setValue('productId', e)
                        }}
                        value={getValues('productId')}
                      />
                    </div>
                  </Col>)}
                <Col lg={3}>
                  <div className="mb-3">
                    <RHSelectField name='isActive' label='Status' list={[
                      { name: 'Active', value: true },
                      { name: 'Expired', value: false },
                    ]} />
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="mb-3">
                    <RHSelectField name='isShownHomePage' label='Home Page' list={[
                      { name: 'Applicable', value: true },
                      { name: 'Not Applicable', value: false },
                    ]} />
                  </div>
                </Col>
                <Col lg={3}>
                  <div className="mb-3">
                    <RHSelectField name='applyFor'
                      label='Apply For'
                      readOnly
                      list={[
                        { name: 'Cart Value', defaultValue: "cartValue" },
                        { name: 'Each Product', value: "eachProduct" },
                      ]} />
                  </div>
                </Col>
                <Col xs={12}>
                  <div className="mb-3">
                    <Form.Label className="form-label d-block">coupon Image</Form.Label>
                    <div className="position-relative d-inline-block">
                      <div className="position-absolute top-100 start-100 translate-middle">
                        <Form.Label htmlFor="couponImage" className="mb-0" data-bs-toggle="tooltip" data-bs-placement="right" title="Select Category Image">
                          <span className="avatar-xs d-inline-block">
                            <span className="avatar-title bg-light border rounded-circle text-muted cursor-pointer">

                              {getValues('couponImage') && showCouponImage ?
                                <i className="ri-delete-bin-5-line" onClick={() => handleDeleteImage('couponImage')}></i> :
                                <i className="ri-image-fill" onClick={() => setShowCouponImage(!showCouponImage)}></i>
                              }
                            </span>
                          </span>
                        </Form.Label>
                        {showCouponImage &&
                          <input className="form-control d-none" id="couponImage" type="file" accept="image/png, image/jpg, image/jpeg"
                            onChange={e => handleFileChange(e, setCouponImagefile)}
                            name='couponImage'
                          />
                        }
                      </div>
                      <div className="avatar-lg">

                        {getValues('couponImage') && showCouponImage ? (
                          <img src={getValues('couponImage')} alt="" id="category-img" className="avatar-md h-auto rounded-3 object-fit-cover" />
                        ) : (
                          <img src={couponimagefile} id="category-img" className="avatar-md h-auto rounded-3 object-fit-cover" />
                        )}
                      </div>
                    </div>
                    <div className="error-msg mt-1">Please add a category images.</div>
                  </div>
                </Col>


                <Col lg={12} className="modal-footer">
                  <div className="hstack gap-2 justify-content-end">
                    <Link className="btn-ghost-danger" to={"/coupons"}>Cancel</Link>
                    <Button variant='primary' id="add-btn" value="Submit" type='submit'>{CouponID ? "Update Coupons" : "Add Coupons"}</Button>
                  </div>
                </Col>
              </Row>
            </FormProvider>
          </div>
        </Container>
      </div>

    </>
  );
};

export default AddCoupon;
